import { render, staticRenderFns } from "./news-navbar.vue?vue&type=template&id=dad3deae&scoped=true&"
import script from "./news-navbar.vue?vue&type=script&lang=js&"
export * from "./news-navbar.vue?vue&type=script&lang=js&"
import style0 from "./news-navbar.vue?vue&type=style&index=0&id=dad3deae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad3deae",
  null
  
)

export default component.exports